module.exports = __webpack_public_path__ + "media/dobry_wzor/dobry-wzor-laureat-img-2-5b0541c1.png";